/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type InboxThreadListItemLastMessageDirection = typeof InboxThreadListItemLastMessageDirection[keyof typeof InboxThreadListItemLastMessageDirection] | null;


export const InboxThreadListItemLastMessageDirection = {
  inbound: 'inbound',
  outbound: 'outbound',
} as const;
